define('components/handlers/filters_finance',[
    'jquery',
    'components/decorator'
], function($, decorator) {

    $.extend(companyInfo.handlers, {


        /**
         * Add a complete new empty filter
         */
        'filters-finance-add': function(e) {

        }
    });

});

